import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useVendorStore from "../HomePage/useVendorStore";
import {
    Button,
    FlexColumn,
    SushiModal,
    WhiteWrapper,
    Wrapper,
} from "../Common/styles.common";
import DDPoHeader from "../Header/DDPoHeader";
import { Loader } from "../Common/Loader";
import { STATUS_BEGIN, STATUS_DONE, PROFILE_INPUT_BORDER } from "utils/constants/others";
import Input from "components/shared/InputTypes/Input";
import styled from "styled-components";
import ShowToast from "../Common/Toast";

const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin: 24px 16px 16px 16px;
  color: #1c1c1c;
`;

const ContentContainer = styled.div`
  padding: 0 0 120px 0;
  overflow-y: auto;
  height: calc(100vh - 180px);
  background: #f8f8fb;
`;

const FormCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin: 0 16px 24px 16px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04);
  border: 1px solid #F2F4F7;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const InputGroup = styled.div`
    width: 100%;
    .wd-100 {
        width: 100%;
    }
`;

const GenerateEwb = () => {
    const { purchaseOrderId } = useParams();
    const navigate = useNavigate();

    const getPurchaseOrders = useVendorStore((state) => state.getPurchaseOrders);
    const getPurchaseOrderStatus = useVendorStore((state) => state.getPurchaseOrderStatus);
    const purchaseOrders = useVendorStore((state) => state.purchaseOrders);
    const generateEwb = useVendorStore((state) => state.generateEwb);
    const generateEwbStatus = useVendorStore((state) => state.generateEwbStatus);

    const [po, setPo] = useState(null);
    const [items, setItems] = useState([]);
    const [tonnage, setTonnage] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const [toastMsg, setToastMsg] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const [form, setForm] = useState({
        vehicle_number: "",
        transporter_id: "",
        distance_in_kms: "",
    });

    useEffect(() => {
        getPurchaseOrders({
            is_item_required: true,
            purchase_order_id: purchaseOrderId,
        }, true);
    }, [purchaseOrderId]);

    useEffect(() => {
        if (getPurchaseOrderStatus === STATUS_DONE && purchaseOrders && purchaseOrders.length > 0) {
            const currentPo = purchaseOrders[0];
            setPo(currentPo);
            if (currentPo.purchase_order_items) {
                setItems(currentPo.purchase_order_items);
                let total = 0;
                for (const item of currentPo.purchase_order_items) {
                    total = total + item.quantity_ordered * (item.weight_per_packet || 0);
                }
                setTonnage(total);
            }
        }
    }, [purchaseOrders, getPurchaseOrderStatus]);

    const handleGenerate = () => {
        if (!form.vehicle_number || !form.transporter_id || !form.distance_in_kms) {
            setToastMsg("Please fill all delivery details");
            setShowToast(true);
            return;
        }

        const payload = {
            purchase_order_number: po.purchase_order_number,
            vendor_ids: [po.vendor_id],
            transporter_id: form.transporter_id,
            vehicle_number: form.vehicle_number,
            distance_in_kms: parseFloat(form.distance_in_kms),
        };

        generateEwb(payload, () => {
            setShowSuccessPopup(true);
        }, (err) => {
            setToastMsg(err || "Failed to generate E-Way Bill");
            setShowToast(true);
        });
    };

    const handleSuccessPopupClose = () => {
        setShowSuccessPopup(false);
        navigate(`/ddPo/details/source/${purchaseOrderId}`);
    }

    return (
        <Wrapper>
            {(showLoader || generateEwbStatus === STATUS_BEGIN) && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(255, 255, 255, 0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}>
                    <Loader />
                </div>
            )}
            {po && (
                <>
                    <DDPoHeader
                        poId={po.id}
                        purchaseOrderNumber={po.purchase_order_number}
                        itemsLength={items.length}
                        tonnage={tonnage}
                        source="details"
                    />
                    <ContentContainer>
                        <SectionTitle>Delivery details</SectionTitle>
                        <FormCard>
                            <InputGroup>
                                <Input
                                    type="text"
                                    label="Vehicle number"
                                    fullWidth={true}
                                    borderColor={PROFILE_INPUT_BORDER}
                                    value={form.vehicle_number}
                                    onChange={(val) => setForm({ ...form, vehicle_number: val })}
                                />
                            </InputGroup>
                            <InputGroup>
                                <Input
                                    type="text"
                                    label="Transporter GSTIN"
                                    fullWidth={true}
                                    borderColor={PROFILE_INPUT_BORDER}
                                    value={form.transporter_id}
                                    onChange={(val) => setForm({ ...form, transporter_id: val })}
                                />
                            </InputGroup>
                            <InputGroup>
                                <Input
                                    type="number"
                                    label="Approx distance (in km)"
                                    fullWidth={true}
                                    borderColor={PROFILE_INPUT_BORDER}
                                    value={form.distance_in_kms}
                                    onChange={(val) => setForm({ ...form, distance_in_kms: val })}
                                />
                            </InputGroup>
                        </FormCard>
                    </ContentContainer>

                    <WhiteWrapper className="po-bottom" style={{ position: 'absolute', bottom: 0, width: '100%', left: 0 }}>
                        <Button
                            className="fs-18 text-white fw-600"
                            onClick={handleGenerate}
                            disabled={generateEwbStatus === STATUS_BEGIN || showLoader}
                            style={{
                                height: '52px',
                                borderRadius: '14px',
                                background: form.vehicle_number && form.transporter_id && form.distance_in_kms ? "#ef4f5f" : "#D1D5DB",
                                boxShadow: form.vehicle_number && form.transporter_id && form.distance_in_kms ? "0px 4px 12px rgba(239, 79, 95, 0.2)" : "none"
                            }}
                        >
                            Generate E-Way Bill
                        </Button>
                    </WhiteWrapper>
                </>
            )}
            {showToast && <ShowToast errorMsg={toastMsg} />}
            <SushiModal visible={showSuccessPopup} isCentered>
                <FlexColumn className="align-items-center p-5">
                    <img src={"/logos/tick_logo.svg"} height="80px" width="80px" />
                    <span className="fs-22 fw-700 my-4 text-center">E-Way bill queued for generation.</span>
                    <span
                        className="fs-18 fw-500 text-red-500"
                        onClick={handleSuccessPopupClose}
                        style={{ cursor: 'pointer' }}
                    >
                        Okay
                    </span>
                </FlexColumn>
            </SushiModal>
        </Wrapper>
    );
};

export default GenerateEwb;
